import { $translate } from '@/utils/i18n';
export const list = [{
    label: $translate('lang.E3202103030045', { defaultText: '用户信息' }),
    key: 'code1',
    makeList: [{
        width: 60,
        span: 8,
        label: $translate('lang.E3202103030048', { defaultText: '姓名' }),
        value: '',
        key: 'customerName'
    }, {
        span: 16,
        width: 92,
        label: $translate('lang.E3202103030049', { defaultText: '联系方式' }),
        value: '',
        key: 'customerTel'
    }, {
        width: 60,
        span: 24,
        label: $translate('lang.E3202103030050', { defaultText: '详细地址' }),
        value: '',
        key: 'customerAddress'
    }]
}, {
    label: $translate('lang.E3202103030046', { defaultText: '机器信息' }),
    key: 'code2',
    makeList: [{
        width: 60,
        span: 8,
        label: $translate('lang.E3202103030051', { defaultText: '内机条码' }),
        value: '',
        key: 'insideBarcode'
    }, {
        width: 92,
        span: 8,
        label: $translate('lang.E3202103030052', { defaultText: '外机条码' }),
        value: '',
        key: 'outsiteBarcode'
    }, {
        width: 120,
        span: 8,
        label: $translate('lang.E3202103030053', { defaultText: '产品编码（套机编码）' }),
        value: '',
        key: 'productCode'
    }, {
        width: 60,
        span: 8,
        label: $translate('lang.E3202103030054', { defaultText: '销售单位' }),
        value: '',
        key: 'saleUnitName'
    }, {
        width: 120,
        span: 8,
        label: $translate('lang.E3202103030056', { defaultText: '厂保开始日期' }),
        value: '',
        key: 'repairStartDate'
    }]
}, {
    label: $translate('lang.E3202103030047', { defaultText: '安装信息' }),
    key: 'code3',
    makeList: [{
        width: 60,
        span: 8,
        label: $translate('lang.E3202103030057', { defaultText: '安装单号' }),
        value: '',
        key: 'installOrderNo'
    }, {
        width: 92,
        span: 8,
        label: $translate('lang.E3202103030058', { defaultText: '购买日期' }),
        value: '',
        key: 'purchaseDate'
    }, {
        width: 60,
        span: 8,
        label: $translate('lang.E3202103030060', { defaultText: '安装日期' }),
        value: '',
        key: 'installDate'
    }, {
        width: 92,
        span: 8,
        label: $translate('lang.E3202103030061', { defaultText: '服务工程师1编码' }),
        value: '',
        key: 'engineerCode1'
    }, {
        width: 120,
        span: 8,
        label: $translate('lang.E3202103030062', { defaultText: '服务工程师1姓名' }),
        value: '',
        key: 'engineerName1'
    }, {
        width: 92,
        span: 8,
        label: $translate('lang.E3202103030063', { defaultText: '服务工程师2编码' }),
        value: '',
        key: 'engineerCode2'
    }, {
        width: 120,
        span: 8,
        label: $translate('lang.E3202103030064', { defaultText: '服务工程师2姓名' }),
        value: '',
        key: 'engineerName2'
    }, {
        width: 92,
        span: 8,
        label: $translate('lang.E3202103030066', { defaultText: '安装单位编码' }),
        value: '',
        key: 'unitCode'
    }, {
        width: 120,
        span: 8,
        label: $translate('lang.E3202103030067', { defaultText: '安装单位名称' }),
        value: '',
        key: 'unitName'
    }]
}];
export const listBar = {
    label: $translate('lang.E3202103030071', { defaultText: '维修信息' }),
    makeList: [{
        width: 112,
        span: 8,
        label: $translate('lang.E3202103030072', { defaultText: '维修单号' }),
        value: '',
        key: 'repairArchivesNo'
    }, {
        width: 112,
        span: 8,
        label: $translate('lang.E3202103030073', { defaultText: '报修时间' }),
        value: '',
        key: 'contactTime'
    }, {
        width: 112,
        span: 8,
        label: $translate('lang.E3202103030075', { defaultText: '修复时间' }),
        value: '',
        key: 'renovateTime'
    }, {
        width: 112,
        span: 8,
        label: $translate('lang.E3202103030076', { defaultText: '服务网点' }),
        value: '',
        key: 'unitName'
    }, {
        width: 112,
        span: 8,
        label: $translate('lang.E3202202180001', { defaultText: '服务网点编码' }),
        value: '',
        key: 'unitCode'
    }, {
        width: 112,
        span: 8,
        label: $translate('lang.E3202103030077', { defaultText: '服务方式' }),
        value: '',
        key: 'serviceMethodCode'
    }, {
        width: 112,
        span: 24,
        label: $translate('lang.E3202103030078', { defaultText: '维修过程' }),
        value: '',
        key: 'repairProcess'
    }, {
        width: 112,
        span: 24,
        label: $translate('lang.E3202103030079', { defaultText: '维修内容' }),
        value: '',
        key: 'maintContent'
    }, {
        width: 112,
        span: 8,
        label: $translate('lang.E3202103030061', { defaultText: '服务工程师1编码' }),
        value: '',
        key: 'engineerCode'
    }, {
        width: 112,
        span: 16,
        label: $translate('lang.E3202103030062', { defaultText: '服务工程师1姓名' }),
        value: '',
        key: 'engineerName'
    }]
};
